import styled from "styled-components"

export const Field = styled.div `

    display: grid;
    width: 100%;
    margin: 0;

`